import React from 'react';
import './Session.css';
import Footer from '../../Components/Footer/Footer';
import SessionList from '../../Components/SessionList/SessionList';

function Session() {

  return (
    <div className="session-container">
      <div className="session-layout">
        <main className="session-content">
          <h1>All Live sessions</h1>
          <p>Select a Live Session.</p>
          <SessionList />
        </main>
      </div>
      <Footer />
    </div>
  );
}

export default Session;
